import {gql} from "@irati/utils/gql"
import fullBranding from "@irati/brand/services/fragments/fullBranding"

export default gql`
  fragment fullTeam on Team {
    uuid
    businessId
    featureFlags
    parentId
    teamName
    teamState
    teamCategory
    public_name
    branding {
      ...fullBranding
    }
    isRootTeam
  }
  ${fullBranding}
`
